import React, { useContext, useState, useEffect } from "react";
import Context from "../../../../context/context";
import { travelTypeEnum } from "../../../../common/enum";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getDay } from "../../../../common/utils";
import { sideEnum } from "../../../../common/enum";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { fetchStartLocationOptionsData } from "../../../../apiCall";

const Orbit = (props) => {
  const { state, dispatch } = useContext(Context);
  const [orbit, setOrbit] = useState(
    props.isInviteBack ? state.selectedOrbitBack : state.selectedOrbit
  );
  const [specificNote, setSpecificNote] = useState(
    props.isInviteBack
      ? state.selectedOrbitBackSpecificNote
      : state.selectedOrbitSpecificNote
  );
  const [orbits, setOrbits] = useState([]);
  const [startLocationOptions, setStartLocationOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [day, setDay] = useState(0);
  const [allOrbits, setAllOrbits] = useState([]);
  const [side, setSide] = useState(props.side ? props.side : state.side);
  const [date] = useState(state.date);
  const [travelType] = useState(
    props.travelType ? props.travelType : state.tripType
  );
  const setStartLocationsDispatch = (data) =>
    dispatch({ type: "SET_START_LOCATION", payload: data });
  const setSelectedOrbitDispatch = (data) =>
    dispatch({
      type: props.isInviteBack
        ? "SET_SELECTED_ORBIT_BACK"
        : "SET_SELECTED_ORBIT",
      payload: data,
    });
  const setSpecificNoteDispatch = (data) =>
    dispatch({
      type: props.isInviteBack ? "SET_ORBIT_BACK_NOTE" : "SET_ORBIT_NOTE",
      payload: data,
    });
  const setSideDispatch = (data) =>
    dispatch({ type: "SET_SIDE", payload: data });
  const history = useHistory();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  // Helpers for oneTimeDate
  const unixDayFromDate = (d) => moment(d).startOf("day").unix();
  const normalizeToUnixDay = (ts) => {
    if (ts == null) return null;
    const num = Number(ts);
    const seconds =
      String(Math.abs(num)).length > 10 ? Math.floor(num / 1000) : num;
    return moment.unix(seconds).startOf("day").unix();
  };

  const selectedUnixDay = () => {
    // for back trip use state.dateBack if present, otherwise state.date
    const d =
      props.isInviteBack || side === "מאומן" ? state.dateBack : state.date;
    return unixDayFromDate(d);
  };

  useEffect(() => {
    getOrbits();
    if (state.isTrain) {
      setSelectedCountry("Poland");
    }
    const momentObject = moment(state.date);
    const dayNumber = momentObject.day();
    setDay(dayNumber);
    getStartLocationOptions();
    
  }, [state, state.date, selectedCountry, side]);

  // only at start
  useEffect(() => {
    // default moldova meanwhile
    setSelectedCountry("Moldova");
    filterOrbits(allOrbits, side);
  }, []);

  useEffect(() => {
    // delete the selectedOrbit on change orbits list
    if (
      orbits.length > 0 &&
      orbit &&
      !orbits.map((o) => o.id).includes(orbit.id)
    ) {
      setOrbit("");
      setSelectedOrbitDispatch("");
    }
  }, [orbits]);

  const getOrbits = async () => {
    let orbitsSrc;
    if (travelType === travelTypeEnum.private) {
      orbitsSrc = state.privateOrbits;
    } else {
      if (state.isTrain) {
        orbitsSrc = state.trainsOrbits;
      } else {
        orbitsSrc = state.sadirOrbits;
      }
    }
    setAllOrbits(orbitsSrc);
    filterOrbits(orbitsSrc, side);
  };

  const setSideOrbit = (value) => {
    setSide(value);
    setSideDispatch(value);
    filterOrbits(allOrbits, value);
  };

  const changeStartLocation = (event) => {
    setSelectedLocation(event.target.value);
    const fullSelectedLocation = startLocationOptions.find(
      (location) => location.hebrewAdress === event.target.value
    );
    setStartLocationsDispatch(fullSelectedLocation);
  };

  const applyCountryFilter = (list) => {
    if (selectedCountry === "Hungary")
      return list.filter((orbit) => orbit.country === "הונגריה");
    if (selectedCountry === "Rumania")
      return list.filter((orbit) => orbit.country === "רומניה");
    if (selectedCountry === "Moldova")
      return list.filter((orbit) => orbit.country === "מולדובה");
    if (selectedCountry === "Austria")
      return list.filter((orbit) => orbit.country === "אוסטריה");
    if (selectedCountry === "Ukraine")
      return list.filter((orbit) => orbit.country === "אוקראינה");
    if (selectedCountry === "Bulgaria")
      return list.filter((orbit) => orbit.country === "בולגריה");
    if (selectedCountry === "Poland")
      return list.filter((orbit) => orbit.country === "פולין");
    return list;
  };

  // New oneTimeDate filter
  const applyOneTimeDateFilter = (list) => {
    const selDay = selectedUnixDay();
    return list.filter((o) => {
      // If oneTimeDate exists and is non empty, require match
      if (Array.isArray(o.oneTimeDate) && o.oneTimeDate.length > 0) {
        const setDays = new Set(
          o.oneTimeDate.map(normalizeToUnixDay).filter(Boolean)
        );
        return setDays.has(selDay);
      }
      // If empty or missing, do not filter out by this rule
      return true;
    });
  };

  const filterOrbits = (orbitsInput, sideVal) => {
    let filtered = orbitsInput;

    // Filter by side
    if (sideVal === sideEnum.toUman) {
      filtered = filtered.filter((o) => o.code === "ka");
    } else if (sideVal === sideEnum.fromUman) {
      filtered = filtered.filter((o) => o.code === "ak");
    }

    // Filter by selected country
    filtered = applyCountryFilter(filtered);

    // Weekly day filter for sadir
    if (travelType === travelTypeEnum.sadir || travelType === travelTypeEnum.train) {
      if (sideVal === "מאומן" || state.side === "מאומן" || props.isInviteBack) {
        const momentObject = moment(state.dateBack);
        const dayNumber = momentObject.day();
        filtered = filtered.filter(
          (o) => Array.isArray(o.weeklyDay) && o.weeklyDay.includes(dayNumber)
        );
      } else {
        const momentObject = moment(state.date);
        const dayNumber = momentObject.day();
        filtered = filtered.filter(
          (o) => Array.isArray(o.weeklyDay) && o.weeklyDay.includes(dayNumber)
        );
      }
    }

    // Apply oneTimeDate filter for both private and sadir
    filtered = applyOneTimeDateFilter(filtered);

    setOrbits(filtered);

    // if there is one orbit- select it
    if(filtered.length === 1){
      setTimeout(() => {
        selectOrbit(filtered[0]);
      }, 500);
    }
  };

  const filterByDate = (list) => {
    if (!date) return list;
    let d = getDay(date);
    setDay(d);
    return list.filter(
      (o) => !o.weeklyDay || o.weeklyDay.length === 0 || o.weeklyDay.includes(d)
    );
  };

  const handleCheckboxChange = (event) => {
    const val = event.target.value;
    setSelectedCountry(val);
    filterOrbits(allOrbits, side);
  };

  const getStartLocationOptions = () => {
    fetchStartLocationOptionsData((response) => {
      if (response.result && response.result.length > 0) {
        setStartLocationOptions(response.result);
        if (!selectedLocation) {
          setSelectedLocation(response.result[0].hebrewAdress);
          setStartLocationsDispatch(response.result[0]);
        }
      }
    });
  };

  const handleClose = () => setOpenDialog(false);

  const hasOrbitsForSelectedCountryAndDate = () => {
    const filteredOrbits = orbits.filter((o) => {
      return (
        o.country === selectedCountry &&
        Array.isArray(o.weeklyDay) &&
        o.weeklyDay.includes(day)
      );
    });
    return filteredOrbits.length > 0;
  };

  const getLabelForSelectedCountry = () => {
    const countryLabels = {
      Hungary: "(דרך קרעסטיר) הונגריה",
      Bulgaria: "בולגריה",
      Austria: "אוסטריה",
      Ukraine: "אוקראינה",
      Rumania: "רומניה",
      Moldova: "מולדובה",
      Poland: "(דרך ליזענסק) פולין",
    };
    return countryLabels[selectedCountry] || "Default Label";
  };

  const handleChange = (event) => {
    const selected = event.target.value;
    selectOrbit(selected);
  };
  
  const selectOrbit = (selected) =>{
    // setSpecificNote("");
    // setSpecificNoteDispatch("");
    setOrbit(selected);
    setSelectedOrbitDispatch(selected);

    if (selected?.daysNotes && travelType === travelTypeEnum.sadir) {
      for (let i = 0; i < selected.daysNotes.length; i++) {
        if (selected.daysNotes[i].day == day) {
          const note = selected.daysNotes[i].note;
          setSpecificNote(note);
          setSpecificNoteDispatch(note);
          break;
        }
      }
    }
  }

  return (
    <div>
      {!props.hideSides ? (
        <div>
          <div className="sidesDiv">
            <div style={{ marginRight: "20px" }}>
              <label>
                מאומן&nbsp;
                <input
                  name="side"
                  type="radio"
                  value="מאומן"
                  onChange={(e) => setSideOrbit(e.target.value)}
                  checked={side === "מאומן"}
                />
              </label>
            </div>
            <div>
              <label>
                לאומן&nbsp;&nbsp;
                <input
                  name="side"
                  type="radio"
                  value="לאומן"
                  onChange={(e) => setSideOrbit(e.target.value)}
                  checked={side === "לאומן"}
                />
              </label>
            </div>
          </div>
        </div>
      ) : null}

      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle>
          <h1 style={{ textAlign: "center", fontSize: "100px" }}>🎉</h1>
        </DialogTitle>
        <DialogContent>
          <p style={{ textAlign: "center", fontWeight: "bold" }}>
            קיבלת 10$ הנחה
          </p>
          <button
            className="nextBtn"
            style={{ marginLeft: "10px" }}
            onClick={handleClose}
          >
            סגור
          </button>
        </DialogContent>
      </Dialog>

      {!props.isInviteBack && !state.isTrain ? (
        <div style={{ maxWidth: "570px" }}>
          {side === "לאומן" ? (
            <h6 style={{ fontWeight: "bold", textAlign: "center" }}>
              {" "}
              :אני נוחת ב{" "}
            </h6>
          ) : (
            <h6 style={{ fontWeight: "bold", textAlign: "center" }}>
              {" "}
              :אני ממריא מ{" "}
            </h6>
          )}

          {/* meanwhile */}
          {/* <FormControlLabel
            value="Hungary"
            control={
              <Checkbox
                checked={selectedCountry === "Hungary"}
                onChange={handleCheckboxChange}
              />
            }
            label={side === "לאומן" ? "(דרך קרעסטיר) הונגריה" : "הונגריה"}
            labelPlacement="start"
          /> */}
          {/*<FormControlLabel
            value="Bulgaria"
            control={
              <Checkbox
                checked={selectedCountry === "Bulgaria"}
                onChange={handleCheckboxChange}
              />
            }
            label="בולגריה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Austria"
            control={
              <Checkbox
                checked={selectedCountry === "Austria"}
                onChange={handleCheckboxChange}
              />
            }
            label="אוסטריה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Ukraine"
            control={
              <Checkbox
                checked={selectedCountry === "Ukraine"}
                onChange={handleCheckboxChange}
              />
            }
            label="אוקראינה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Rumania"
            control={
              <Checkbox
                checked={selectedCountry === "Rumania"}
                onChange={handleCheckboxChange}
              />
            }
            label="רומניה"
            labelPlacement="start"
          />*/}
          <FormControlLabel
            value="Moldova"
            control={
              <Checkbox
                checked={selectedCountry === "Moldova"}
                onChange={handleCheckboxChange}
              />
            }
            label="מולדובה"
            labelPlacement="start"
          />
          {/*}
          <FormControlLabel
            value="Poland"
            control={
              <Checkbox
                checked={selectedCountry === "Poland"}
                onChange={handleCheckboxChange}
              />
            }
            label={side === "לאומן" ? "(דרך ליזענסק) פולין" : "פולין"}
            labelPlacement="start"
          />*/}
        </div>
      ) : null}

      {props.isInviteBack && !state.isTrain ? (
        <div style={{ maxWidth: "570px" }}>
          <h6 style={{ fontWeight: "bold", textAlign: "center" }}>
            {" "}
            :אני ממריא מ{" "}
          </h6>
          <FormControlLabel
            value="Hungary"
            control={
              <Checkbox
                checked={selectedCountry === "Hungary"}
                onChange={handleCheckboxChange}
              />
            }
            label=" הונגריה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Austria"
            control={
              <Checkbox
                checked={selectedCountry === "Austria"}
                onChange={handleCheckboxChange}
              />
            }
            label="אוסטריה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Ukraine"
            control={
              <Checkbox
                checked={selectedCountry === "Ukraine"}
                onChange={handleCheckboxChange}
              />
            }
            label="אוקראינה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Bulgaria"
            control={
              <Checkbox
                checked={selectedCountry === "Bulgaria"}
                onChange={handleCheckboxChange}
              />
            }
            label="בולגריה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Rumania"
            control={
              <Checkbox
                checked={selectedCountry === "Rumania"}
                onChange={handleCheckboxChange}
              />
            }
            label="רומניה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Moldova"
            control={
              <Checkbox
                checked={selectedCountry === "Moldova"}
                onChange={handleCheckboxChange}
              />
            }
            label="מולדובה"
            labelPlacement="start"
          />
          <FormControlLabel
            value="Poland"
            control={
              <Checkbox
                checked={selectedCountry === "Poland"}
                onChange={handleCheckboxChange}
              />
            }
            label="פולין"
            labelPlacement="start"
          />
        </div>
      ) : null}

      {selectedCountry && (travelType === travelTypeEnum.sadir || travelType === travelTypeEnum.train) ? (
        <>
          <FormControl sx={{ minWidth: 100, margin: "10px 0" }}>
            <InputLabel id="demo-simple-select-label">מסלול</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={orbit}
              label="Orbit"
              autoWidth
              onChange={handleChange}
              className="orbitSelect"
            >
              {orbits
                .filter((o) => {
                  if (o.isShowCustomers === undefined) return true;
                  if (o.isShowCustomers.length === 0) return true;
                  return !o.isShowCustomers.some((tested) => {
                    return (
                      tested.dayNumber === day && tested.selected === false
                    );
                  });
                })
                .sort((a, b) => a.hour - b.hour)
                .map((o) => {
                  const formattedHour = o.hour.toString().padStart(2, "0");
                  const formattedMinutes =
                    o.minutes == null
                      ? console.log("Orbit minutes is null", o) || "00"
                      : o.minutes.toString().padStart(2, "0");
                  return (
                    <MenuItem key={o.id} value={o}>
                      {o.price}$ | {formattedHour}:{formattedMinutes} | {o.name}
                    </MenuItem>
                  );
                })}
              {/* <button
                className="nextBtn"
                style={{ width: "200px", marginLeft: "30px" }}
                onClick={() => history.push("/askOrbit")}
              >
                לא מצאת ? בקש מסלול
              </button> */}
            </Select>
          </FormControl>
        </>
      ) : (
        <>
          {selectedCountry && (
            <FormControl sx={{ minWidth: 100, margin: "10px 0" }}>
              <InputLabel id="demo-simple-select-label">מסלול</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={orbit}
                label="Orbit"
                autoWidth
                onChange={handleChange}
                className="orbitSelect"
              >
                {orbits.map((o) => (
                  <MenuItem key={o.id} value={o}>
                    {o.name}
                  </MenuItem>
                ))}
                <button
                  className="nextBtn"
                  style={{ width: "200px", marginLeft: "30px" }}
                  onClick={() => history.push("/askOrbit")}
                >
                  לא מצאת ? בקש מסלול
                </button>
              </Select>
            </FormControl>
          )}
        </>
      )}

      {state.side === "מאומן" || props.isInviteBack ? (
        <>
          <p>{state.selectedOrbitBack.note}</p>
          <p>{state.selectedOrbitBackSpecificNote}</p>
          {/* <p>{state.selectedOrbitSpecificNote}</p>
          <p>{state.selectedOrbit.note}</p> */}
        </>
      ) : (
        <>
          <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>
            {state.selectedOrbit.note}
          </p>
          <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>
            {state.selectedOrbitSpecificNote}
          </p>
        </>
      )}

      {(state.side === "מאומן" || props.isInviteBack) &&
      state.tripType === travelTypeEnum.sadir  ? (
        <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>
          {state.customerSettings.returnNote} 
        </p>
      ) : (
        <></>
      )}

      
      {(state.side === "מאומן" || props.isInviteBack) &&
      state.tripType === travelTypeEnum.train  ? (
        <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>
          איסוף בירידה מהציון ימינה 
          <br></br>
          יש להגיע חצי שעה לפני 
        </p>
      ) : (
        <></>
      )}


            {(state.side === "לאומן" ) &&
      state.tripType == 'רכבת' ? (
        <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>
          יש להגיע שעה לפני 
        </p>
      ) : (
        <></>
      )}

      {(state.side === "מאומן" || props.isInviteBack) &&
      state.tripType === travelTypeEnum.private ? (
        <div>
          <div>
            {state.selectedOrbit ? (
              <>
                <FormControl sx={{ minWidth: 100, margin: "10px 0" }}>
                  <InputLabel id="demo-simple-select-label">
                    בחירת נקודת איסוף
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    onChange={changeStartLocation}
                    label="נקודת איסוף"
                    value={selectedLocation}
                    autoWidth
                    className="orbitSelect"
                  >
                    {startLocationOptions.map((startLocation) => (
                      <MenuItem
                        key={startLocation.id}
                        value={startLocation.hebrewAdress}
                      >
                        {startLocation.hebrewAdress}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : null}

      {(state.side === "מאומן" || props.isInviteBack) && state.tripType !== travelTypeEnum.train ? (
        <div className="noteDiv">
          <a href="./timeCalc">לצפיה בהמלצת שעות יציאה מאומן לחץ כאן</a>
          <p>
            אני מאשר כי ידוע לי שחברת פאייכלה אינה נושאת באחריות על עיכובים
            בגבולות או כל עיכוב אחר שיהיה וההחלטה על שעת היציאה הינה באחריותי
            בלבד
          </p>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Orbit;
